"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const react_ga_1 = __importDefault(require("react-ga"));
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("../../assets/constants/constants");
const blipChatBot_1 = __importDefault(require("../../utils/blipChatBot"));
const HomeFooter_1 = __importDefault(require("./homeFooter/HomeFooter"));
const HomeHeader_1 = __importDefault(require("./homeHeader/HomeHeader"));
const SectionAmenities_1 = __importDefault(require("./sectionAmenities/SectionAmenities"));
const SectionDifferentials_1 = __importDefault(require("./sectionDifferentials/SectionDifferentials"));
const SectionFeatured_1 = __importDefault(require("./sectionFeatured/SectionFeatured"));
const SectionLocation_1 = __importDefault(require("./sectionLocation/SectionLocation"));
const SectionTestimonials_1 = __importDefault(require("./sectionTestimonials/SectionTestimonials"));
const RoutesPaths_1 = require("../../routes/RoutesPaths");
react_ga_1.default.initialize(`${constants_1.GOOGLE_ANALYTICS_UA}`);
const Home = () => {
    const beforeLocationRef = (0, react_1.useRef)(null);
    const location = (0, react_router_dom_1.useLocation)();
    const scrollToRef = (0, react_1.useCallback)((section) => {
        var _a;
        const sections = {
            location: beforeLocationRef,
            getSection(sectionsObj) {
                return (sectionsObj === null || sectionsObj === void 0 ? void 0 : sectionsObj[section]) || null;
            },
        };
        (_a = sections.getSection(sections).current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null, "360 Su\u00EDtes - Aluguel por temporada sem burocracias"),
            react_1.default.createElement("meta", { name: "description", content: "Apartamentos mobiliados. Hospedagens flex\u00EDveis. Check-in digital. Atendimento 24h. Servi\u00E7os completos. Localiza\u00E7\u00E3o. Conforto. Design. Profissionalismo. Sem fiador. Sem cheque cau\u00E7\u00E3o. Sem burocracia." }),
            react_1.default.createElement("link", { rel: "canonical", href: `${window.location.origin}${RoutesPaths_1.routesPaths.root}` })),
        react_1.default.createElement("div", { ref: beforeLocationRef }),
        react_1.default.createElement(HomeHeader_1.default, null),
        react_1.default.createElement(SectionLocation_1.default, null),
        react_1.default.createElement(SectionDifferentials_1.default, null),
        react_1.default.createElement(SectionFeatured_1.default, null),
        react_1.default.createElement(SectionAmenities_1.default, null),
        react_1.default.createElement(SectionTestimonials_1.default, null),
        react_1.default.createElement(HomeFooter_1.default, { scrollToRef: scrollToRef }),
        react_1.default.createElement(blipChatBot_1.default, null)));
};
exports.default = Home;
